import React from 'react'
import { Settings, RefreshCw } from 'lucide-react'
import { Button } from '@/components/ui/button'

interface JobberHeaderProps {
  onSync: () => void
  isSyncing: boolean
}

export function JobberHeader({ onSync, isSyncing }: JobberHeaderProps) {
  return (
    <div className="flex items-center justify-between">
      <div>
        <h1 className="text-3xl font-bold">Jobber CRM Integration</h1>
        <p className="text-muted-foreground mt-1">
          Manage customer data, jobs, invoices, and estimates from Jobber CRM
        </p>
      </div>
      <div className="flex gap-2">
        <Button variant="outline">
          <Settings className="w-4 h-4 mr-2" />
          Settings
        </Button>
        <Button onClick={onSync} disabled={isSyncing}>
          <RefreshCw className={`w-4 h-4 mr-2 ${isSyncing ? 'animate-spin' : ''}`} />
          Sync Now
        </Button>
      </div>
    </div>
  )
}

